import { useSelectMilestoneFieldQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(id: string) {
  const tuple = useSelectMilestoneFieldQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.milestones.map((node) => ({
        id: node.id,
        name: node.id,
        displayName: node.title
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
